import {
  CreateSubscriptionInput,
  useCreateSubscriptionMutation as useBaseCreateSubscriptionMutation
} from 'generated/graphql';
import { validationUtil } from 'modules';
import * as yup from 'yup';



export const __formSchema = yup.object({
  cardNumber: validationUtil.nonEmptyStringSchema.required('Card number is required.'),
  expirationDate: validationUtil.nonEmptyStringSchema.required('Expiration date is required.'),
  cvv: validationUtil.nonEmptyStringSchema.required('CVV is required.'),
  country: yup.string().required('Country is required.'),
  usState: yup.string().required('State is required.'),
  city: yup.string().required('City is required.'),
  address: yup.string().required('Address is required.'),
  zipCode: validationUtil.nonEmptyStringSchema.max(250).required('Zip code is required.'),
  discountCode: yup.string()
}).required();

export type IFormData = yup.InferType<typeof __formSchema>;



export function useCreateSubscriptionMutation() {
  const [fnRunMutation, createSubscriptionMutationTuple] = useBaseCreateSubscriptionMutation();

  const fnWrappedCreateSubscriptionMutation = async (args: CreateSubscriptionInput) =>
    fnRunMutation({
      variables: {
        input: {
          ...args
        }
      }
    });

  return [fnWrappedCreateSubscriptionMutation, createSubscriptionMutationTuple] as const;
}
